import Axios from "axios";
import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { Button, Card } from "react-bootstrap";
import { MultiSelect } from "react-multi-select-component";
import { useHotKey } from "../Hooks";
import { CustomError } from "../Models/CustomError";
import { FilterProps } from "../Models/FilterProps";
import { Options } from "../Models/Options";
import { Tag } from "../Models/Tag";
import { isCustomError } from "../Utils";

interface IProps {
    updateFilterProps: (filterProps: FilterProps) => void;
}
export const Filter: React.FunctionComponent<IProps> = (
    props: IProps
): JSX.Element => {
    const [filterSearchText, setfilterSearchText] = useState("");
    const { updateFilterProps } = props;
    const [tagArr, setTagArr] = useState<Tag[]>([]);
    const [selectedTags, setSelectedTags] = useState<Options[]>([]);
    const [postErrors, setPostErrors] = useState<CustomError>();
    const [showFilter, setShowFilter] = useState<boolean>(false);

    const onSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setfilterSearchText(e.target.value);
    };

    const findHotKeySet = new Set<string>();
    findHotKeySet.add("AltLeft");
    findHotKeySet.add("KeyF");
    useHotKey(findHotKeySet,()=>{
        onShowFilter();
    });

    const hideHotKeySet = new Set<string>();
    hideHotKeySet.add("AltLeft");
    hideHotKeySet.add("KeyH");
    useHotKey(hideHotKeySet, ()=>{
        onHideFilter();
    });


    const onSearchApply = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        e.preventDefault();
        if (filterSearchText !== "" || selectedTags.length > 0) {
            var filterProps: FilterProps = {
                searchText: filterSearchText,
                fitlerTags: selectedTags.map((option) => option.value),
            };
            updateFilterProps(filterProps);
        }
    };

    const onClearFilter = (
        e: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => {
        e.preventDefault();
        setfilterSearchText("");
        setSelectedTags([]);
        updateFilterProps({ searchText: "", fitlerTags: [] });
    };

    const onShowFilter = (
        e?: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => {
        if(e){
            e.preventDefault();
        }
        setShowFilter(true);
    };

    const onHideFilter = (
        e?: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => {
        if(e){
            e.preventDefault();
        }
        setShowFilter(false);
    };
    
    const inputRef:React.MutableRefObject<HTMLInputElement | null> = useRef(null);

    useEffect(() => {
        if(showFilter){
            inputRef.current?.focus();
        }
        async function getTags() {
            try {
                const response = await Axios.get(
                    `${process.env.REACT_APP_API_URL}/api/v1/tags`
                );
                const tags = response.data as Tag[];
                setTagArr(tags);
            } catch (error) {
                if(isCustomError(error)){
                    setPostErrors(error);
                }
            }
        }
        getTags();
    }, [setTagArr, showFilter]);

    return (
        <>
            <Card>
                <Card.Header>
                    <button
                        className="btn btn-primary"
                        hidden={showFilter}
                        onClick={(e) => {
                            onShowFilter(e);
                        }}
                    >
                        Show <u>F</u>ilters
                    </button>
                    <button
                        className="btn btn-primary"
                        hidden={!showFilter}
                        onClick={(e) => {
                            onHideFilter(e);
                        }}
                    >
                        <u>H</u>ide Filters
                    </button>
                </Card.Header>

                <Card.Body hidden={!showFilter}>
                    <form>
                        <div className="filter-container">
                            <div className="form-group filter-item">
                                <label>Search:</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    placeholder="search text"
                                    id="search"
                                    onChange={(e) => onSearchChange(e)}
                                    value={filterSearchText}
                                    ref={inputRef}
                                />
                            </div>

                            <div className="form-group filter-item">
                                <label>Tags:</label>

                                <MultiSelect
                                    options={tagArr.map((tag: Tag) => {
                                        return {
                                            label: tag.name,
                                            value: tag.id,
                                        };
                                    })}
                                    value={selectedTags}
                                    labelledBy={"Select"}
                                    onChange={setSelectedTags}
                                />
                            </div>
                        </div>
                        <Button
                            type="submit"
                            className="btn btn-primary"
                            onClick={(e:React.MouseEvent<HTMLElement, MouseEvent>) => onSearchApply(e)}
                        >
                            Apply
                        </Button>
                        <button
                            className="btn btn-primary"
                            onClick={(e) => onClearFilter(e)}
                        >
                            Clear
                        </button>
                    </form>

                    {postErrors?.errors.map((error: string) => (
                        <small className="form-text text-muted">{error}</small>
                    ))}
                </Card.Body>
            </Card>
        </>
    );
};
